import { useContext } from "react";
import { Avatar } from "@mui/material";

import MUIChip from "../../../Component/UI/MUIChip/MUIChip";
import classes from "./Suggestions.module.css";
// import { DiscoveryContext } from "../../Discovery/discovery-context";
import ProductVariant from "../../Discovery/ProductVariant";

export default function Suggestions({ options, onDelete, discoveryCtx }) {
  return (
    <div className={classes.container}>
      {options.map((item, index) => (
        <MUIChip
          avatar={
            item?.variants?.length > 0 ? (
              <ProductVariant
                editable={!discoveryCtx.loading && !discoveryCtx.is_launched}
                triggerId="basic-menu"
                variants={item.variants}
                index={index + 1}
              >
                <Avatar className={classes.chip_avatar}>
                  {item?.variants?.length}
                </Avatar>
              </ProductVariant>
            ) : null
          }
          key={item.name}
          label={item.name}
          className={classes.chip}
          onDelete={
            !discoveryCtx.loading && !discoveryCtx.is_launched
              ? () => onDelete(item.name)
              : undefined
          }
        />
      ))}
    </div>
  );
}
